
import VueConfetti from 'vue-confetti'

export default ({ Vue }) => {
  Vue.use(VueConfetti)
}
